import {
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    SimpleChanges,
} from "@angular/core";
import { RxComponent } from "../../../core/components/common/rx.component";
import { FormBuilder, FormGroup } from "@angular/forms";

declare var $: any;
declare var moment: any;

@Component({
    selector: "itpx-filter-daterange",
    templateUrl: "./filter-daterange.component.html",
    styleUrls: ["./filter-daterange.component.css"],
})
export class FilterDaterangeComponent extends RxComponent implements OnInit {
    @Input() private filters: any;
    @Output() filterChanged = new EventEmitter<any>();
    private filterFields: any;
    private fromValue: any;
    private toValue: any;
    selectAllForm: FormGroup;

    constructor(private fb: FormBuilder) {
        super();
    }

    ngOnInit() {
        this.selectAllForm = this.fb.group({
            selectAll: [true],
        });
        this.getFilterFields();

        this.selectAllForm.controls.selectAll.valueChanges
            .distinctUntilChanged()
            .bindToLifecycle(this)
            .subscribe((change) => {
                if (change) {
                    this.clearStartEndDate();
                    this.emitChangeOnDateRange();
                }
            });
    }

    ngOnChanges(change: SimpleChanges) {
        if (change["filters"]) {
            this.clearStartEndDate();
            if (this.selectAllForm)
                this.selectAllForm.controls.selectAll.setValue(true);
        }
    }

    private clearStartEndDate() {
        this.getFilterFields();
        this.fromValue = null;
        this.toValue = null;
    }

    private getFilterFields() {
        this.filterFields = {
            key: this.filters.key,
            minOnly: 0,
            cutOffUpper: 5,
            cutOffLower: 5,
            formatter: (item) => {
                return item;
            },
            level: 1,
        };
    }

    private emitChangeOnDateRange() {
        const startDate = this.fromValue
            ? moment(this.fromValue * 1000)
                  .startOf("day")
                  .toISOString()
            : null;

        const endDate = this.toValue
            ? moment(this.toValue * 1000)
                  .endOf("day")
                  .toISOString()
            : null;

        this.filterChanged.emit({
            id: this.filters.key,
            startDate,
            endDate,
        });
    }

    fromValueChanged($event: any) {
        this.fromValue = $event;
        if ($event) {
            this.selectAllForm.controls.selectAll.setValue(false);
            this.emitChangeOnDateRange();
        }
    }

    toValueChanged($event: any) {
        this.toValue = $event;
        if ($event) {
            this.selectAllForm.controls.selectAll.setValue(false);
            this.emitChangeOnDateRange();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/filter-daterange/filter-daterange.component.ts